import Fault from '@isyscore/classes/fault';
import Axios from 'axios';
import { STANDARD_ERR_ORDER } from '../../order-define';
export const errStandard = () => {
    return {
        errOrder: STANDARD_ERR_ORDER,
        errInterceptor(err) {
            const defaultError = '网络连接有点问题，请稍后再试';
            const { config, message = defaultError } = err;
            const isCancel = Axios.isCancel(err);
            if (isCancel) {
                throw new Fault({
                    isCancel,
                    config,
                    code: 'CANCELED',
                    status: -1,
                    message: err.message || defaultError,
                    data: null,
                    detail: null
                });
            }
            const { request, response = {} } = err;
            const { data = null, status = 0, originalData } = response;
            const { code = 'ERROR', detail = null, message: dataMessage } = originalData || data || {};
            let beautifulMessage = dataMessage || message;
            if (process.env.NODE_ENV === 'production') {
                if (status === 500)
                    beautifulMessage = defaultError;
            }
            throw new Fault({
                code,
                status,
                message: beautifulMessage,
                isCancel,
                config,
                request,
                response,
                data,
                detail
            });
        }
    };
};
